export default {
  header: "Results",
  view: "results"
};
